Ext.ns('mx.app.widget');

mx.app.widget.HelpForm = Ext.extend(Ext.Panel, {
    border: false,
    layout: 'mx-form',
    autoHeight: true,

    labels: {
        text:
            "If you have any questions or need help operating, please contact us on email at <a href='mailto:support@maxoptra.com'>support@maxoptra.com</a> and we shall contact you shortly.",
    },

    defaults: {
        anchor: '-5',
    },

    initComponent: function() {
        mx.app.widget.HelpForm.superclass.initComponent.apply(this, arguments);

        var tpl = new Ext.XTemplate(this.labels.text);

        this.html = tpl.apply();
    },
});
